module.exports = __webpack_public_path__ + "static/img/name7.38bf0a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name7.png
// module id = lZ8x
// module chunks = 1